import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const opts = {
  icons: {
    iconfont: 'mdi' as const,
  },
  theme: {
    themes: {
      light: {
        primary: '#409cff',
        secondary: '#c9e2ff',
        terciary: '#192E3F', // on brand navy
        tertiary: '#192E3F', // Because speling
      },
    },
  },
};

export default new Vuetify(opts);
